import { getDefaultStore } from 'jotai';
import { csrfTokenAtom } from '@/store/authAtoms';

const store = getDefaultStore();

export function getCsrfToken(): string | undefined {
  return store.get(csrfTokenAtom) ?? undefined;
}

export function setCsrfToken(token: string | null): void {
  store.set(csrfTokenAtom, token);
}
